import { endAccountSession } from '../auth/accountSession';
import { BACKEND_BASE_URL } from '../../config/appConfig';
import { browserNavigation } from './browserNavigation';

const encodeNavigationParam = (value: string): string =>
  encodeURIComponent(value).replace(/%2F/gi, '/').replace(/%3A/gi, ':');

const buildBackendNavigationUrl = (path: string, nextPath: string): string => {
  const url = new URL(BACKEND_BASE_URL);
  const basePath = url.pathname.replace(/\/$/, '');
  const authPath = path.replace(/^\/+/, '');
  url.pathname = `${basePath}/${authPath}`.replace(/\/{2,}/g, '/');

  let absoluteNext = nextPath;
  try {
    absoluteNext = new URL(nextPath, window.location.href).toString();
  } catch {
    absoluteNext = new URL('/', window.location.href).toString();
  }

  url.search = `?next=${encodeNavigationParam(absoluteNext)}`;
  return url.toString();
};

export const redirectToLogin = (nextPath: string): void => {
  endAccountSession();
  browserNavigation.assign(buildBackendNavigationUrl('/login', nextPath));
};

export const redirectToLogout = (
  nextPath: string = window.location.href
): void => {
  endAccountSession();
  browserNavigation.replace(buildBackendNavigationUrl('/logout', nextPath));
};
